import { createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const cleanSearch = val => {
    const stopWords = [ 'a', 'an', 'and', 'are', 'as', 'at', 'be', 'but', 'by', 'for', 'if', 'in', 'into', 'is', 'it', 'no', 'not', 'of', 'on', 'or', 'such', 'that', 'the', 'their', 'then', 'there', 'these', 'they', 'this', 'to', 'was', 'will', 'with' ]
    let cleanSearch = val.toLowerCase()
    stopWords.forEach(word => {
      const wordRegex = new RegExp(`\\b${word.toLowerCase()}\\b`, 'g')
      cleanSearch = cleanSearch.replaceAll(wordRegex, '')
    })
    cleanSearch = cleanSearch.trim().replace(/\s+/g, ' ')
    return cleanSearch.split(' ').filter(x => x)
  }

  const stringMatches = (haystack, needles) => {
    haystack = haystack.toLowerCase().trim()
    return needles.some(needle => haystack.includes(needle.toLowerCase()))
  }

  const appConfig = {
    data(){
      return {
        search: '',
        hasFocus: false,
        terms: [],
        debouncedAnnouncement: '',
      }
    },
    mounted(){
      window.addEventListener('focusin', e => {
        this.hasFocus = this.$refs.appRoot.contains(document.activeElement)
      })
      window.addEventListener('click', e => {
        this.hasFocus = this.$refs.appRoot.contains(e.target)
      })
      window.coolHelperFunctions.coolAjax({
        action: 'fetch_smart_questions'
      }, success => {
        this.terms = success?.data?.terms || []
      }, error => {
        console.error(error)
      })

      //For screen readers
      this.updateAnnouncement = window.coolHelperFunctions.debounce(() => {
        const termsCount = this.filteredTerms.length
        const resultsCount = this.filteredTerms.reduce((sum, t) => sum + t.posts.length, 0)
        this.debouncedAnnouncement = `Found ${termsCount} terms with ${resultsCount} results.`
      }, 750)
    },
    computed: {
      hasSearchText() {
        return cleanSearch(this.search).length > 0
      },
      showPopup() {
        return this.hasFocus && this.hasSearchText
      },
      filteredTerms() {
        const search = cleanSearch(this.search)
        if(!search.length){
          return []
        } else {
          return this.terms.map(term => {
            let termMatch = stringMatches(term.name, search)
            const matchedPosts = term.posts.filter(p => {
              return stringMatches(p.post_title, search) || stringMatches(p.description, search) || stringMatches(p.additional_keywords, search)
            })

            if(termMatch){
              return term
            } else if(matchedPosts.length){
              return { ...term, posts: matchedPosts }
            } else {
              return null
            }
          }).filter(x => x)
        }
      }
    },
    methods: {
      cancelSearch() {
        this.search = ''
        this.hasFocus = false
        this.debouncedAnnouncement = ''
      }
    },
    watch: {
      search(val) {
        if (!cleanSearch(val).length) {
          this.debouncedAnnouncement = ''
        }
      },
      filteredTerms() {
        if (!this.hasSearchText) {
          return
        }
        // Debounce the announcement for screen readers
        this.updateAnnouncement()
      }
    }

  }

  function initApp(){
    const els = document.querySelectorAll('.smart-question-typeahead')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig)
        app.mount(el)
      })
    }
  }

  initApp()
}